import React from 'react';
import CanvasCardFront from './Cards/CanvasCardFront';
// JSX-based card components kept but not used for NuLifeSpan/CVS — canvas is now used instead
// import { NuLifeSpanCardFront } from './Cards/NuLifeSpanCard';
// import { CVSCardFront } from './Cards/CVSCard';
import { WalmartCardFront } from './Cards/WalmartCard';

export default function CardFront({ cardData, groupData, PrimaryGn, mId, bin, pcn, beneficiaryName, className }) {
    const cardType = cardData?.classnames;

    // Resolve props (direct props take priority over cardData)
    const memberId    = mId          || cardData?.mId          || '';
    const binNumber   = bin          || cardData?.bin          || '';
    const pcnNumber   = pcn          || cardData?.pcn          || '';
    const groupNumber = PrimaryGn    || groupData?.groupnumber || '';

    // Walmart: keep JSX card unchanged
    if (cardType === 'walmart_card') {
        return (
            <WalmartCardFront
                bin={binNumber}
                pcn={pcnNumber}
                groupNumber={groupNumber}
                memberId={memberId}
                className={className}
            />
        );
    }

    // CVS: canvas-based with cvs-front.png
    if (cardType === 'cvs_card') {
        return (
            <CanvasCardFront
                isCvs={true}
                bin={binNumber}
                pcn={pcnNumber}
                groupNumber={groupNumber}
                memberId={memberId}
                className={className}
            />
        );
    }

    // Default (NuLifeSpan / glic_card / any other): canvas-based with card-front.png
    return (
        <CanvasCardFront
            isCvs={false}
            bin={binNumber}
            pcn={pcnNumber}
            groupNumber={groupNumber}
            memberId={memberId}
            className={className}
        />
    );
}
